import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { Input } from '../../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../../shared/http-client';
import { FormFooter } from '../../../../elements/form-footer';
import { FieldError } from '../../../../elements/field-error/field-error';
import { Select } from '../../../../elements/select';
import { TextArea } from '../../../../elements/text-area';
import { FileInputElement } from '../../../../elements/file-input';
import { RadioGroup } from '../../../../elements/radio-group';



// construccion del objeto yup de validacion del cuestionario
let obligado = {
    //cost: Yup.string().required('obligatorio'),
    type: Yup.mixed().required('obligatorio'),
    center: Yup.mixed().required('obligatorio'),
    mileage: Yup.string().required('obligatorio'),
};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    type: null,
    center: null,
    mileage: '',
};

export const MantenimientoTabForm = ({
    item,
    vehicleId,
    close,
    doDelete
}: {
    item?: any;
    vehicleId?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };

    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [tiposMentenimiento, setTiposMentenimiento] = useState<any | null>([]);
    const [centros, setCentros] = useState<any | null>([]);

    const [date, setDate] = useState<string>(item ? data?.date : dayjs().format('YYYY-MM-DDTHH:mm:ss'));
    const [nextDate, setNextDate] = useState<string>(item ? data?.next_date : dayjs().format('YYYY-MM-DDTHH:mm:ss'));
    const [isDeleted, setIsDeleted] = useState<boolean>(false);


    // Load initial data
    useEffect(() => {
        if (item) {
            setData(item);
        }
        api(`/fleet/maintenance-types/`, 'GET');
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };

        const formattedDate = date ? new Date(date).toISOString().slice(0, 16) : "";

        after.date = formattedDate || data?.date;

        if (!item) {
            after.vehicle = vehicleId;


        } else {
            after.vehicle = after.vehicle.id;
        }


        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        let formdata = new FormData();

        if (enviaremos.document) {
            if (enviaremos.document.document) {
                formdata.append(
                    'document',
                    enviaremos.document.document[0],
                    enviaremos.document.document[0].name
                );
            }
        }

        for (let key in enviaremos) {
            if (key !== 'document') {
                formdata.append(key, enviaremos[key] ? enviaremos[key] : "");
            }
        }

        if (isDeleted) {
            api(`/fleet/maintenances/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            if (enviaremos.id) {
                // update

                api(`/fleet/maintenances/${enviaremos.id}/`, 'PATCH', formdata, true);
            } else {
                // create

                api('/fleet/maintenances/', 'POST', formdata, true);
            }
        }
    };

    const openInNewTab = () => {
        window.open(data?.display_url, '_blank', 'noreferrer');
    };

    const handleChangeDate = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setDate(value);

    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('maintenances')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    window.location.reload();
                    close();
                }
            }
            if (state.path.includes('maintenance-types')) {
                setTiposMentenimiento(state.data.results);
                api(`/fleet/centers/`, 'GET');
            }
            if (state.path.includes('centers')) {
                setCentros(state.data.results);
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            }else{
                 toast.error('Server Error');
            }
        }
    }, [state]);

    return (
        <Formik
            initialValues={data || initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">

                    <Select
                        name="type"
                        label={t(
                            'common.label.tipo-mantenimiento'
                        )}
                        placeholder="Select"
                        items={tiposMentenimiento}
                        value={
                            data?.type ||
                            values.type
                        }
                        onChange={(value) => {
                            setFieldValue(
                                'type',
                                value.type
                            );
                        }}
                    />

                    <FieldError touched={touched} errors={errors} field={"type"} />

                    <Select
                        name="center"
                        label={t(
                            'common.label.centro'
                        )}
                        placeholder="Select"
                        items={centros}
                        value={
                            data?.center ||
                            values.center
                        }
                        onChange={(value) => {
                            setFieldValue(
                                'center',
                                value.center
                            );
                        }}
                    />

                    <FieldError touched={touched} errors={errors} field={"center"} />


                    <Input
                        label={t('common.label.costo')}
                        type="text"
                        placeholder={t('common.label.costo')}
                        name="cost"
                        value={values.cost}
                        onChange={(value) =>
                            setFieldValue('cost', value.cost)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'cost'}
                    />

                    <div className='pt-2'>
                        <TextArea
                            label={t(
                                'common.label.observaciones'
                            )}
                            placeholder={t(
                                'common.label.observaciones'
                            )}
                            name="observations"
                            value={values.observations}
                            onChange={(value: any) =>
                                setFieldValue(
                                    'observations',
                                    value.observations
                                )
                            }
                        />
                    </div>

                    <Input
                        label={t('common.label.kilometraje-mantenimiento')}
                        type="number"
                        placeholder={t('common.label.kilometraje-mantenimiento')}
                        name="mileage"
                        value={values.mileage}
                        onChange={(value) =>
                            setFieldValue('mileage', value.mileage)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'mileage'}
                    />

                    <div className="mt-[11px] pb-8 w-full">
                        {/* --------------------FECHA------------------- */}

                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                            {t('common.labels.date')}
                        </label>
                        <input
                            id="dateInput"
                            type="datetime-local"
                            step="1" // Permite solo minutos (sin segundos)
                            value={date || data?.date} // Mostrar sin segundos en el input
                            onChange={handleChangeDate}
                        />
                    </div>

                    {/*  <Input
                        label={t('common.label.kilometraje-proximo-mantenimiento')}
                        type="number"
                        placeholder={t('common.label.kilometraje-proximo-mantenimiento')}
                        name="next_mileage"
                        value={values.next_mileage}
                        onChange={(value) =>
                            setFieldValue('next_mileage', value.next_mileage)
                        }
                    />

                    <div className="mt-[11px] pb-8 w-full">
                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                            {t('common.label.fecha-proximo-mantenimiento')}
                        </label>
                        <input
                            id="dateInput"
                            type="datetime-local"
                            step="1" // Permite solo minutos (sin segundos)
                            value={nextDate || data?.next_date} // Mostrar sin segundos en el input
                            onChange={handleChangeNextDate}
                        />
                    </div> */}

                    <div className='pt-8'>
                        {data?.document ? <div className='flex'>
                            {!isDeleted ? <div className='flex cursor-pointer' onClick={openInNewTab}>
                                <span className='border border-gray-400 rounded py-2 px-4 text-sm'>{t('common.label.ver-document')}</span>
                            </div> : ''}
                            {!isDeleted ? <div className='flex cursor-pointer ml-8' onClick={() => {
                                setFieldValue('document', null);
                                setFieldValue('display_url', null);
                                setIsDeleted(true);
                            }}>
                                <span className='border border-red-500 rounded p-2 text-sm text-red-500'>{t('common.button.delete-document')}</span>
                            </div> : ''}
                        </div> : ''
                        }
                    </div>

                    <div className='w-full pb-8 pt-4'>
                        <span className="block text-sm font-semibold leading-6 text-gray-700">{data?.document ? t('common.label.cambiar-document') : t('common.form-label.documento')}</span>
                        <FileInputElement
                            name="document"
                            onChange={(value) => {
                                // Extraemos directamente el FileList del objeto que retorna el FileInputElement
                                setFieldValue('document', value);
                            }}
                        />
                    </div>



                    <div className='pt-48'></div>


                    <FormFooter
                        item={item}
                        doDelete={doDelete}
                        doSubmit={handleSubmit}
                        close={close}
                    />
                </form>
            )}
        </Formik>
    );
};